export default __webpack_public_path__ + "static/assets/aa88ba144b88f36f247f4e6b122f8719.gif";